/**
 * AnalystLayout — Minimal layout for the /analyst cross-org dashboard.
 *
 * Unlike AppLayout (which is org-scoped with sidebar navigation),
 * this layout is for the analyst's cross-org overview. It provides
 * a simple header with branding and navigation back to org views.
 */

import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BarChart3, LogOut } from 'lucide-react';
import { Button } from './ui/button';

export function AnalystLayout() {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            {/* Left: Branding */}
            <div className="flex items-center gap-3">
              <Link to="/analyst" className="flex items-center gap-2 text-foreground hover:text-primary transition-colors">
                <BarChart3 className="h-5 w-5" />
                <span className="font-semibold text-lg">AdCanvas</span>
                <span className="text-sm text-muted-foreground font-normal">Analyst Dashboard</span>
              </Link>
            </div>

            {/* Right: User info + sign out */}
            <div className="flex items-center gap-4">
              <span className="text-sm text-muted-foreground hidden sm:inline">
                {user?.email}
              </span>
              <Button variant="ghost" size="sm" onClick={signOut}>
                <LogOut className="h-4 w-4 mr-1" />
                Sign Out
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
